
export default {
  name: "DiscountReceived",
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      inViewLen: 4,
      isShowAll: false
    }
  },
  computed: {
    itemsLen() {
      return this.items.length
    },
    isShowViewBtn() {
      return this.itemsLen > this.inViewLen
    },
    displayItems() {
      if (!this.isShowAll && this.isShowViewBtn) {
        return this.items.slice(0, this.inViewLen)
      }
      return this.items
    }
  },
  methods: {
    getClass(index) {
      // 最后一个item && 为奇数
      return this.itemsLen - 1 === index && this.itemsLen % 2 !== 0 ? "received-item-full" : ""
    },
    toggleViewBtnClick() {
      this.isShowAll = !this.isShowAll
    }
  }
}
